import { IClientContextBase } from './client-context-base';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class ServerClientContextLoader {
    abstract load(request: any): IClientContextBase;
}